// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1779314121032
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/components/ParadigmaTable/ParadigmaTable.scss
// module id = ./src/components/ParadigmaTable/ParadigmaTable.scss
// module chunks = 0